import {ConsentString} from '../../node_modules/consent-string/dist/consent-string';

const m6IABManager = {
    IAB_COOKIE_NAME: 'euconsent',
    IAB_COOKIE_WEBSITE_VENDOR_LIST_VERSION: 'website_vendor_list_version',
    IAB_CMP_ID: 136,
    debug: false,
    consentData: null,
    cookieVendorListVersion: 1,
    vendorlist: {},

    /** Public functions */
    init: function () {
        this._log('Init');

        const iabCookieValue = this._getCookie(m6IABManager.IAB_COOKIE_NAME);
        this.consentData = new ConsentString(iabCookieValue !== null ? iabCookieValue : '');
        this.cookieVendorListVersion = this.consentData.getVendorListVersion();

        if (!this.isVendorListIsDefined()) {
            this._log('Custom vendorlist is missing');
            return;
        }

        this.vendorlist = window.m6Gdpr_vendorlist;
        this.consentData.setGlobalVendorList(window.m6Gdpr_vendorlist);

        this.consentData.setCmpId(this.IAB_CMP_ID);
        this.consentData.setCmpVersion(1);
        this.consentData.setConsentScreen(1);
        this.consentData.setConsentLanguage('fr');

        // Website vendor list version cookie exist ?
        if (this._getCookie(this.IAB_COOKIE_WEBSITE_VENDOR_LIST_VERSION) === null &&
            window.hasOwnProperty('m6GdprJSONExtra') &&
            typeof m6GdprJSONExtra['website_vendor_list_version'] !== 'undefined') {
            this._setCookie(
                this.IAB_COOKIE_WEBSITE_VENDOR_LIST_VERSION,
                parseInt(m6GdprJSONExtra['website_vendor_list_version'])
            );
        }

        // Check website vendor list version is upgraded
        if (this.isVendorListIsDefined() && (iabCookieValue === null || !this._isVendorListVersionUpToDate())) {
            if (typeof m6Gdpr !== 'undefined')
                window.dispatchEvent(new CustomEvent(m6Gdpr.OPEN_GDPR));
            else if(typeof dataLayer !== 'undefined') {
                // Launch event to GTM for open CMP if m6Gdpr is not defined
                dataLayer.push({
                    'event': 'CMP - Open popin',
                    'eventCategory': 'CMP',
                    'eventAction': 'Open popin',
                    'eventLabel': ''
                });
            }
        }

        const _this = this;
        if (typeof m6Gdpr !== 'undefined') {
            window.addEventListener(m6Gdpr.REGISTER_IAB_INFOS, function (event) {
                // Save vendors lit version
                if (window.hasOwnProperty('m6GdprJSONExtra') &&
                    typeof m6GdprJSONExtra['website_vendor_list_version'] !== 'undefined') {
                    _this._setCookie(
                        _this.IAB_COOKIE_WEBSITE_VENDOR_LIST_VERSION,
                        parseInt(m6GdprJSONExtra['website_vendor_list_version'])
                    );
                }

                let userChoices = [];

                if (event.detail.choices === null) { // Accept all
                    const vendors = _this.getVendors();
                    for (let i = 0; i < vendors.length; i++)
                        userChoices.push({id: vendors[i].id, isEnabled: true});
                } else if (typeof event.detail.choices === 'string') userChoices = JSON.parse(event.detail.choices);
                else userChoices = event.detail.choices;

                _this._log('REGISTER_IAB_INFOS:userChoices', userChoices);

                // Default accept all purposes
                let purposeIDs = [];
                const purposes = _this.getPurposes();
                for (let i = 0; i < purposes.length; i++) purposeIDs.push(purposes[i].id);
                _this._log('addEventListener:purposeIDsAlowed', purposeIDs);
                _this.consentData.setPurposesAllowed(purposeIDs);

                // Parse vendor IDs allowed
                let vendorIDsAllowed = [];
                for (let i = 0; i < userChoices.length; i++) {
                    if (userChoices[i].isEnabled) vendorIDsAllowed.push(parseInt(userChoices[i].id));
                }

                _this.consentData.setVendorsAllowed(vendorIDsAllowed);
                _this._log('addEventListener:getVendorsAllowed', _this.consentData.getVendorsAllowed());

                _this._setCookie(m6IABManager.IAB_COOKIE_NAME, _this.consentData.getConsentString());
            });
        }
    },

    getPurposes: function () {
        return (typeof this.vendorlist === 'object' && typeof this.vendorlist.purposes !== 'undefined')
            ? this.vendorlist.purposes : [];
    },

    getVendors: function (purposeId) {
        // Check purpose ID exist
        if (Number.isInteger(purposeId)) {
            purposeId = parseInt(purposeId);
            const purposes = this.getPurposes();
            let flag = false;
            for (let i = 0; i < purposes.length; i++) {
                if (purposeId === Number.parseInt(purposes[i].id))
                    flag = true;
            }

            if (!flag) purposeId = null;
        } else purposeId = null;

        // Get vendors by purpose ID if is defined
        let vendors = [];
        if (typeof this.vendorlist === 'object' && typeof this.vendorlist.vendors !== 'undefined') {
            for (let i = 0; i < this.vendorlist.vendors.length; i++) {
                if (purposeId === null || this.vendorlist.vendors[i].purposeIds.indexOf(purposeId) > -1) {
                    vendors.push({
                        id: this.vendorlist.vendors[i].id,
                        name: this.vendorlist.vendors[i].name,
                        policyUrl: this.vendorlist.vendors[i].policyUrl,
                        purposeIds: this.vendorlist.vendors[i].purposeIds,
                        isDisabled: this.vendorlist.vendors[i].legIntPurposeIds.length > 0
                    });
                }
            }
        } else this._log('Something wrong with vendorlist');

        vendors.sort(function (a, b) {
            if (a.id < b.id) return -1;
            else if (a.id > b.id) return 1;
            return 0;
        });

        return vendors;
    },

    getPurposesAllowed: function () {
        if (this._getCookie(m6IABManager.IAB_COOKIE_NAME) === null) {
            let purposeIDs = [];
            const purposes = this.getPurposes();
            for (let i = 0; i < purposes.length; i++) {
                purposeIDs.push(purposes[i].id);
            }
            return purposeIDs;
        }

        return this.consentData.getPurposesAllowed();
    },

    getVendorsAllowed: function () {
        /* If consentData vendorList version is different of vendor list, ask default enable all vendors */
        if (this._getCookie(m6IABManager.IAB_COOKIE_NAME) === null || !this._isVendorListVersionUpToDate()) {
            let vendorIDs = [];
            const vendors = this.getVendors();
            for (let i = 0; i < vendors.length; i++) {
                vendorIDs.push(vendors[i].id);
            }

            return vendorIDs;
        }

        return this.consentData.getVendorsAllowed();
    },

    getAll: function () {
        let data = [];
        const purposes = this.getPurposes();

        for (let i = 0; i < purposes.length; i++) {
            let purpose = purposes[i];
            purpose.vendors = this.getVendors(purposes[i].id);

            data.push(purpose);
        }

        return data;
    },

    getVendorList: function () {
        return this.vendorlist;
    },

    getConsentString: function () {
        return this.isVendorListIsDefined() ? this.consentData.getConsentString() : '0';
    },

    isVendorListIsDefined: function () {
        return typeof window.m6Gdpr_vendorlist !== 'undefined';
    },

    getVendorConsents: function (parameters) {
        // Check if cookie exist, else return data=false
        if (m6IABManager._getCookie(m6IABManager.IAB_COOKIE_NAME) === null) {
            return false;
        }

        // Manage vendors white list by parameter
        let vendorIDsWhiteList = [];
        if (Array.isArray(parameters)) {
            for (let i = 0; i < parameters.length; i++) {
                if (Number.isInteger(parseInt(parameters[i])))
                    vendorIDsWhiteList.push(parseInt(parameters[i]));
            }
        }

        // Get purpose IDs and this status
        let purposeConsents = {};
        const purposesAllowed = m6IABManager.getPurposesAllowed();
        const purposes = m6IABManager.getPurposes();
        for (let i = 0; i < purposes.length; i++) {
            purposeConsents[purposes[i].id] = (purposesAllowed.indexOf(purposes[i].id) > -1);
        }

        // Get purpose IDs and this status
        let vendorConsents = {};
        const vendorsAllowed = m6IABManager.getVendorsAllowed();
        const vendors = m6IABManager.getVendors();
        for (let i = 0; i < vendors.length; i++) {
            if (vendorIDsWhiteList.length > 0 && vendorIDsWhiteList.indexOf(vendors[i].id) > -1 ||
                vendorIDsWhiteList.length === 0) {
                vendorConsents[vendors[i].id] = (vendorsAllowed.indexOf(vendors[i].id) > -1);
            }
        }

        // Construct data
        return {
            metadata: m6IABManager.consentData.getMetadataString(),
            gdprApplies: true, // if in EU
            hasGlobalScope: true, // true if the vendor consent data is retrieved from the global cookie, false if a publisher-specific (or publisher-group-specific)
            purposeConsents: purposeConsents,
            vendorConsents: vendorConsents
        };
    },

    getConsentData: function (parameters) {
        // Check if cookie exist, else return data=false
        if (m6IABManager._getCookie(m6IABManager.IAB_COOKIE_NAME) === null) {
            return false;
        }

        // Parameter can contain consentStringVersion
        if (Number.isInteger(parameters)) {
            if (parseInt(parameters) !== m6IABManager.consentData.getVersion()) {
                return false;
            }
        }

        return {
            gdprApplies: true, // if in EU
            hasGlobalScope: true, // true if the vendor consent data is retrieved from the global cookie, false if a publisher-specific (or publisher-group-specific)
            //consentData: m6IABManager.consentData.getConsentString() // TODO this value from cookie
            consentData: m6IABManager._getCookie(m6IABManager.IAB_COOKIE_NAME) // TODO this value from cookie
        };
    },

    getPublisherConsents: function (parameters) {
        let purposesIDsWhiteList = [];
        if (Array.isArray(parameters)) {
            for (let i = 0; i < parameters.length; i++) {
                if (Number.isInteger(parseInt(parameters[i]))) purposesIDsWhiteList.push(parseInt(parameters[i]));
            }
        }

        let standardPurposeConsents = {};
        const aPurposes = m6IABManager.getPurposes();
        const aPurposesAllowed = m6IABManager.getPurposesAllowed();
        for (let i = 0; i < aPurposes.length; i++) {
            if (purposesIDsWhiteList.length > 0 && purposesIDsWhiteList.indexOf(aPurposes[i].id) > -1 ||
                purposesIDsWhiteList.length === 0) {
                standardPurposeConsents[aPurposes[i].id] = (aPurposesAllowed.indexOf(aPurposes[i].id) > -1);
            }
        }

        return {
            metadata: m6IABManager.consentData.getMetadataString(),
            gdprApplies: true,
            hasGlobalScope: true,
            standardPurposeConsents: standardPurposeConsents,
            customPurposeConsents: {}
        };
    },

    /** Private functions */
    _getCookie: function (cname) {
        const nameEQ = cname + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) === 0) {
                return c.substring(nameEQ.length, c.length);
            }
        }
        return null;
    },

    _setCookie: function (cname, cvalue) {
        if (!this.isVendorListIsDefined()) {
            this._log('Custom vendorlist is missing');
            return;
        }

        const exdays = 395;
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        const expires = "expires=" + d.toUTCString();
        var cookieSting = cname + "=" + cvalue + ";" + expires + ";path=/";

        // Subdomains is enabled
        if (window.hasOwnProperty('m6GdprJSONExtra')
            && typeof m6GdprJSONExtra.cookies_all_subdomains !== 'undefined') {
            if (m6GdprJSONExtra.cookies_all_subdomains === true && m6IABManager._getDomain() !== null) {
                cookieSting += (';domain=' + m6IABManager._getDomain());
            }
        }

        document.cookie = cookieSting;
    },

    _getDomain: function () {
        var elems = window.location.hostname.split('.');
        if (elems.length >= 2) {
            elems = elems.splice(elems.length - 2, 2);
            return elems.join('.');
        }

        return null;
    },

    _isVendorListVersionUpToDate: function () {
        var websiteVendorListVersion_config = 1;
        if (window.hasOwnProperty('m6GdprJSONExtra') && typeof m6GdprJSONExtra['website_vendor_list_version'] !== 'undefined') {
            websiteVendorListVersion_config = parseInt(m6GdprJSONExtra['website_vendor_list_version']);
        } else return true;

        var websiteVendorListVersion_cookie = this._getCookie(this.IAB_COOKIE_WEBSITE_VENDOR_LIST_VERSION);
        if (websiteVendorListVersion_cookie !== null) {
            return websiteVendorListVersion_config <= parseInt(websiteVendorListVersion_cookie);
        }

        return false;
    },

    _log: function (msg, values) {
        if (this.debug)
            console.log('%cIAB Manager%c ' + msg,
                'background: #F44336; border-radius: 2px; color: #fff; padding: 2px 10px;', 'color: #333',
                typeof values === 'undefined' ? '' : values
            );
    }
};

/** CMP IAB Interface */
window.__cmp = function (command, parameters, callback) {
    if (['getVendorConsents', 'getConsentData', 'ping', 'getVendorList', 'getPublisherConsents'].indexOf(command) === -1) {
        console.error('CMP command is not available');
        return;
    }

    if (typeof callback !== 'function') {
        console.error('CMP callback is not a function');
        return;
    }

    let data = {};
    switch (command) {
        case 'getVendorConsents':
            data = m6IABManager.getVendorConsents(parameters);
            break;
        case 'getConsentData':
            data = m6IABManager.getConsentData(parameters);
            break;
        case'ping':
            data = {
                gdprAppliesGlobally: true,
                cmpLoaded: true
            };
            break;
        case 'getPublisherConsents':
            data = m6IABManager.getPublisherConsents(parameters);
            break;
        case 'getVendorList':
            // Parameter can contain vendorListVersion
            if (Number.isInteger(parameters)) {
                if (parseInt(parameters) !== m6IABManager.vendorlist.vendorListVersion) {
                    data = null;
                    break;
                }
            }

            data = m6IABManager.getVendorList();
            break;
    }

    callback(data, true);
};

window.m6IABManager = m6IABManager;